/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalHelpContact } from './PortalHelpContact';
import {
    PortalHelpContactFromJSON,
    PortalHelpContactFromJSONTyped,
    PortalHelpContactToJSON,
    PortalHelpContactToJSONTyped,
} from './PortalHelpContact';

/**
 * 
 * @export
 * @interface PortalAuthStart
 */
export interface PortalAuthStart {
    /**
     * 
     */
    resident_first_name: string | null;
    /**
     * 
     */
    help_contact: PortalHelpContact | null;
}

/**
 * Check if a given object implements the PortalAuthStart interface.
 */
export function instanceOfPortalAuthStart(value: object): value is PortalAuthStart {
    if (!('resident_first_name' in value) || value['resident_first_name'] === undefined) return false;
    if (!('help_contact' in value) || value['help_contact'] === undefined) return false;
    return true;
}

export function PortalAuthStartFromJSON(json: any): PortalAuthStart {
    return PortalAuthStartFromJSONTyped(json, false);
}

export function PortalAuthStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAuthStart {
    if (json == null) {
        return json;
    }
    return {
        
        'resident_first_name': json['resident_first_name'],
        'help_contact': PortalHelpContactFromJSON(json['help_contact']),
    };
}

export function PortalAuthStartToJSON(json: any): PortalAuthStart {
    return PortalAuthStartToJSONTyped(json, false);
}

export function PortalAuthStartToJSONTyped(value?: PortalAuthStart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resident_first_name': value['resident_first_name'],
        'help_contact': PortalHelpContactToJSON(value['help_contact']),
    };
}

